import React from "react"
import Header from "./header/header"
import Footer from "./footer/footer"
import CookieConsent from 'react-cookie-consent'
import SEO from './seo/seo';

import "../styles/vendor/bootstrap.min.css"
import "../styles/vendor/linearicons.min.css"
import "../styles/vendor/fontawesome-all.min.css"
import "../styles/plugins/animation.min.css"
import "../styles/plugins/slick.min.css"
import "../styles/plugins/magnific-popup.css"
import "../styles/plugins/easyzoom.css"
import "../styles/style.css"

import "../styles/global.css"

/**
 * Site shell. Pass `seo={{ title, description, image, article }}` from a page
 * so each page gets its own title and description instead of the site default.
 */
export default function Layout({ seo = {}, children }) {
    return (
        <main>
            <SEO {...seo} />
            <Header></Header>
            {children}
            <Footer></Footer>

            <CookieConsent
                style={{ background: "#000000a8" }}
                buttonStyle={{
                    background: "#c5622b",
                    color: "white",
                }}
                declineButtonStyle={{ background: "#173842" }}
                flipButtons enableDeclineButton
                buttonText="Accept"
                declineButtonText="Decline"
                cookieName="gatsby-gdpr-google-analytics">
                We use cookies to understand how the site is used and to improve it.{" "}
            </CookieConsent>
        </main>
    )
}
